export enum ApprovalStatusEnum {
  ON_QUEUED = 'ON_QUEUED',
  AWAITING = 'AWAITING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  CANCELLED = 'CANCELLED'
}

export enum ApprovalTypeEnum {
  REPORT_TO = 'REPORT_TO',
  REPORT_TO_LIMIT = 'REPORT_TO_LIMIT',
  GROUP = 'GROUP',
  GROUP_LIMIT = 'GROUP_LIMIT'
}
